import { defineComponent } from 'vue';
import CategoryElevenFileUploadComponent from '@/components/CategoryEleven/CategoryElevenFileUploadComponent.vue';
export default defineComponent({
    name: 'CategoryElevenFileUploadDialog',
    props: {
        propSelected: Array
    },
    components: { CategoryElevenFileUploadComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
